import { addCartItemHelper, updateCartItemHelper } from "../utils/cartHelpers";
import { cartStorage } from "./cartStorage";

export function addToCart(product) {
  const existingProducts = cartStorage.get()?.value;

  const cartProducts = addCartItemHelper({
    existingProducts,
    product,
  });
  const expiryTime = 24 * 60 * 60 * 1000;
  const now = new Date().getTime();
  const cart = {
    value: cartProducts,
    expiry: now + expiryTime,
  };

  cartStorage.set(cart);
  return cart;
}

export function updateCart(product) {
  const existingProducts = cartStorage.get()?.value;

  const cartProducts = updateCartItemHelper({
    existingProducts,
    product,
  });

  const expiryTime = 24 * 60 * 60 * 1000;
  const now = new Date().getTime();
  const cart = {
    value: cartProducts,
    expiry: now + expiryTime,
  };

  cartStorage.set(cart);
  return cart;
}

export function removeFromCart({ productID, variantID }) {
  const existingProducts = cartStorage.get();
  if (!existingProducts || !existingProducts.value) {
    return [];
  }

  const updated = existingProducts.value.filter(
    (item) =>
      (item._id === productID && item.variant._id !== variantID) ||
      item._id !== productID,
  );

  const expiryTime = 24 * 60 * 60 * 1000;
  const now = new Date().getTime();
  const cart = {
    value: updated,
    expiry: now + expiryTime,
  };

  cartStorage.set(cart);
  return cart;
  // setPopUpPage(true);
}

export function getCart() {
  return cartStorage.get();
}
